import { PageRequest, PaginationData } from '@elotech/components';

export const buildPageRequest = (pagination?: PaginationData): PageRequest => ({
  page: pagination?.number || 0,
  size: pagination?.size || 20
});
